import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareAuthenticatedHeaders } from './utils/headers'
import type { User, CurrentUser } from '../types'

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_URL}/api/v1`,
    prepareHeaders: prepareAuthenticatedHeaders,
  }),
  tagTypes: ['Users', 'CurrentUser'],
  endpoints: builder => ({
    currentUser: builder.query<CurrentUser, void>({
      query: () => ({
        url: '/user/',
      }),
      providesTags: ['CurrentUser'],
    }),
    updateCurrentUser: builder.mutation<CurrentUser, Partial<UpdateUser>>({
      query: data => ({
        url: '/user/',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['CurrentUser'],
    }),
    searchUser: builder.query<User[], string>({
      query: query => ({
        url: `/search/users?q=${query}`,
      }),
    }),
  }),
})

interface UpdateUser {
  domains: number[]
  themes: number[]
}

export const { useCurrentUserQuery, useLazySearchUserQuery } = userApi
